/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Scope_Event_Run_DescInputs */



/**
* | output |
* | --- |
* | "Act for the user on one tournament they choose (identity only if they choose none)" |
*
* @param {Developer_Scope_Event_Run_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_scope_event_run_desc = /** @type {((inputs?: Developer_Scope_Event_Run_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Scope_Event_Run_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agir pour l'utilisateur sur un tournoi qu'il choisit (identité seule s'il n'en choisit aucun)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actuar por el usuario en un torneo que elija (solo identidad si no elige ninguno)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Agir pelo usuário em um torneio que ele escolher (só identidade se não escolher nenhum)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Agire per l'utente su un torneo che sceglie (solo identità se non ne sceglie nessuno)")
	return /** @type {LocalizedString} */ ("Act for the user on one tournament they choose (identity only if they choose none)")
});